import { CalendarCheck } from 'lucide-react';
import { useNavigate } from 'react-router';
import { Card, CardHeader, CardContent, CardTitle } from './ui/card';

const CertificatesStub = () => {
  return (
    <Card className="w-[calc(100vw-1.5rem)] md:w-[calc(100vw-250px-1.5rem)] lg:w-[47rem] overflow-hidden border-none shadow-none">
      <CardHeader className="px-0 py-0 pt-4">
        <div className="flex flex-col">
          <div className="group flex flex-col items-center gap-3 mx-auto">
            <div className="rounded-full bg-primary/10 p-6">
              <CalendarCheck className="h-12 w-12 text-primary/80" />
            </div>
            <CardTitle className="text-lg font-medium text-gray-800 group-hover:text-primary transition-colors">
              Справки отсутствуют
            </CardTitle>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4 py-4">
        <div className="text-center space-y-1 text-center">
          <div className="text-sm text-muted-foreground pb-2">
            <p className="max-w-[300px]  mx-auto">
              Предоставить необходимые справки можно администратору
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
export default CertificatesStub;
